export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-2.479b83e5.png";